// extracted by mini-css-extract-plugin
export default {"controls":"LR9ke","monthControls":"_3XQqx","monthButton":"_1QNyD","back":"_1vsnr","month":"_3zQZ_","loading":"_1urgo","next":"_3i2DD","days":"_2LEY0"};